<!-- Default node -->
<svg:foreignObject
  *ngIf="nodeModel.node.type === 'default'"
  class="selectable"
  #nodeContent
  [attr.width]="nodeModel.size().width"
  [attr.height]="nodeModel.size().height"
  (pointerStart)="pullNode(); selectNode()"
>
  <default-node
    #htmlWrapper
    [selected]="nodeModel.selected()"
    [style.width]="styleWidth()"
    [style.height]="styleHeight()"
    [style.max-width]="styleWidth()"
    [style.max-height]="styleHeight()"
  >
    <div [outerHTML]="nodeModel.text()"></div>

    <handle type="source" [position]="nodeModel.sourcePosition()" />
    <handle type="target" [position]="nodeModel.targetPosition()" />
  </default-node>
</svg:foreignObject>

<!-- Template node -->
<svg:foreignObject
  *ngIf="nodeModel.node.type === 'html-template' && nodeTemplate"
  class="selectable"
  [attr.width]="nodeModel.size().width"
  [attr.height]="nodeModel.size().height"
  (pointerStart)="pullNode()"
>
  <div
    #htmlWrapper
    class="wrapper"
    [style.width]="styleWidth()"
    [style.height]="styleHeight()"
  >
    <ng-container
      [ngTemplateOutlet]="nodeTemplate"
      [ngTemplateOutletContext]="{ $implicit: { node: nodeModel.node, selected: nodeModel.selected } }"
      [ngTemplateOutletInjector]="injector"
    />
  </div>
</svg:foreignObject>

<!-- Component node -->
<svg:foreignObject
  *ngIf="nodeModel.isComponentType"
  class="selectable"
  [attr.width]="nodeModel.size().width"
  [attr.height]="nodeModel.size().height"
  (pointerStart)="pullNode()"
>
  <div
    #htmlWrapper
    class="wrapper"
    [style.width]="styleWidth()"
    [style.height]="styleHeight()"
  >
    <ng-container
      [ngComponentOutlet]="$any(nodeModel.node.type)"
      [ngComponentOutletInputs]="nodeModel.componentTypeInputs()"
      [ngComponentOutletInjector]="injector"
    />
  </div>
</svg:foreignObject>

<!-- Default group node -->
<svg:rect
  *ngIf="nodeModel.node.type === 'default-group'"
  [resizable]="nodeModel.resizable()"
  [gap]="3"
  [resizerColor]="nodeModel.color()"
  class="default-group-node"
  rx="5"
  ry="5"
  [class.default-group-node_selected]="nodeModel.selected()"
  [attr.width]="nodeModel.size().width"
  [attr.height]="nodeModel.size().height"
  [style.stroke]="nodeModel.color()"
  [style.fill]="nodeModel.color()"
  (pointerStart)="pullNode(); selectNode()"
/>

<!-- Template group node  -->
<svg:g
  *ngIf="nodeModel.node.type === 'template-group' && groupNodeTemplate"
  class="selectable"
  (pointerStart)="pullNode()"
>
  <ng-container
    [ngTemplateOutlet]="groupNodeTemplate"
    [ngTemplateOutletContext]="{ $implicit: { node: nodeModel.node, selected: nodeModel.selected, width: nodeModel.width, height: nodeModel.height } }"
    [ngTemplateOutletInjector]="injector"
  />
</svg:g>

<!-- Resizer -->
<ng-container *ngIf="nodeModel.resizerTemplate() as template">
  <ng-container *ngIf="nodeModel.resizable()">
    <ng-template [ngTemplateOutlet]="template" />
  </ng-container>
</ng-container>

<!-- Handles -->
<ng-container *ngFor="let handle of nodeModel.handles()">
  <svg:circle
    *ngIf="!handle.template"
    class="default-handle"
    [attr.cx]="handle.offset().x"
    [attr.cy]="handle.offset().y"
    [attr.stroke-width]="handle.strokeWidth"
    r="5"
    (pointerStart)="startConnection($event, handle)"
    (pointerEnd)="endConnection(handle)"
  />

  <svg:g
    *ngIf="handle.template"
    [handleSizeController]="handle"
    (pointerStart)="startConnection($event, handle)"
    (pointerEnd)="endConnection(handle)"
  >
    <ng-container *ngTemplateOutlet="handle.template; context: handle.templateContext" />
  </svg:g>

  <svg:circle
    *ngIf="showMagnet()"
    class="magnet"
    [attr.r]="nodeModel.magnetRadius"
    [attr.cx]="handle.offset().x"
    [attr.cy]="handle.offset().y"
    (pointerEnd)="endConnection(handle); resetValidateConnection(handle)"
    (pointerOver)="validateConnection(handle)"
    (pointerOut)="resetValidateConnection(handle)"
  />
</ng-container>

<!-- Toolbar -->
<svg:foreignObject
  *ngIf="toolbar() as toolbar"
  [attr.width]="toolbar.size().width"
  [attr.height]="toolbar.size().height"
  [attr.transform]="toolbar.transform()"
>
  <ng-container [ngTemplateOutlet]="toolbar.template()" />
</svg:foreignObject>
